module.exports = __webpack_public_path__ + "img/partners14.04016126.png";